import React from 'react';

import { FICTION } from '../../Pages';
import { CONTENT_TYPES } from '../../../core/constants';

export default {
  path: FICTION.pageURL,
  async action() {
    const { default: CommonManager } =
      await import('../common/ContentManagerView/CommonManager');
    return (
      <CommonManager
        key={'list'}
        contentType={CONTENT_TYPES.FICTION}
        page={FICTION}
      />
    );
  },
};
